import { DietaryTags } from 'web-common/src/shared/Enums';

interface HeroBackground {
  backgroundImage: string;
  backgroundImageTablet: string;
  backgroundImageDesktop: string;
}

export const CERTIFIED_DIETARY_HERO_BACKGROUND: Partial<Record<DietaryTags, HeroBackground>> = {
  [DietaryTags.HALAL]: {
    backgroundImage:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/halal-dietary/hero-mobile.jpg',
    backgroundImageTablet:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/halal-dietary/hero-tablet.jpg',
    backgroundImageDesktop:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/halal-dietary/hero-desktop.jpg',
  },
};
